@switch (state?.status) {
  @case ('loading') {
    <div role="status" aria-live="polite" aria-busy="true">
      <ng-content select="[skeleton]"></ng-content>
      @if (slow) {
        <p class="mt-3 text-center text-body-s text-vw-muted">{{ 'components.state.slow' | translate }}</p>
      }
    </div>
  }
  @case ('error') {
    <vw-error-state
      [compact]="compact"
      [titleKey]="errorTitleKey"
      [messageKey]="errorMessageKey"
      (retry)="retry.emit()"
    ></vw-error-state>
  }
}
